import * as firebase from 'firebase/app';
import { GoogleAuthProvider, FacebookAuthProvider, getAuth, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyB7vfkAMFbQh9KkOapCyqr5HVpl063f_uk",
    authDomain: "ecoideas-8333a.firebaseapp.com",
    projectId: "ecoideas-8333a",
    storageBucket: "ecoideas-8333a.appspot.com",
    messagingSenderId: "292495417842",
    appId: "1:292495417842:web:0f2bc220e63c790e4f0b6b",
    measurementId: "G-54JQRNGTGV"
  };

if (typeof window !== 'undefined' && !firebase.getApps().length) {
    const app = firebase.initializeApp(firebaseConfig);
}

export { firebase };

export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const signFirebase = (from,next) => {
    signInWithPopup(getAuth(), from === "google" ? googleProvider : facebookProvider.addScope("public_profile"))
        .then(async (result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const provider = from == "google" ? GoogleAuthProvider : FacebookAuthProvider
            const credential = provider.credentialFromResult(result);
            const accessToken = credential?.accessToken;
            const idToken = from === "google" ? credential?.idToken : result.user.providerData[0].uid
            next({
                accessToken,idToken
            })
            try {                     
            } catch (error) {
                console.log(error);

            }
        }).catch((error) => {

        });

}